import PaymentInformationReadOnlyBlock, { PaymentInformationReadOnlyBlockProps } from './PaymentInformationReadOnlyBlock';

export type { PaymentInformationReadOnlyBlockProps };
export default PaymentInformationReadOnlyBlock;
